import { css } from 'styled-components';

import { Transitions, TRANSITION_MS } from 'theme/const';

export const fade = css`
  .${Transitions.fade}-enter,.${Transitions.fade}-appear {
    opacity: 0;
  }

  .${Transitions.fade}-exit {
    opacity: 1;
  }

  .${Transitions.fade}-enter-active, .${Transitions.fade}-appear-active {
    opacity: 1;
  }

  .${Transitions.fade}-exit-active {
    opacity: 0;
  }

  .${Transitions.fade}-enter-active,
    .${Transitions.fade}-exit-active,
    .${Transitions.fade}-appear-active {
    transition: opacity ${TRANSITION_MS}ms ease-in-out;
  }
`;

export const collapse = css`
  .${Transitions.collapse}-enter, .${Transitions.collapse}-appear {
    transform: translateY(-30px);
  }

  .${Transitions.collapse}-exit {
    transform: translateY(0);
  }

  .${Transitions.collapse}-enter-active, .${Transitions.collapse}-appear-active {
    transform: translateY(0);
  }

  .${Transitions.collapse}-exit-active {
    transform: translateY(-30px);
  }

  .${Transitions.collapse}-enter-active,
    .${Transitions.collapse}-appear-active,
    .${Transitions.collapse}-exit-active {
    transition: transform ${TRANSITION_MS}ms ease-in-out;
  }
`;
